/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserGroupDetailsUpdate
 */
export interface UserGroupDetailsUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupDetailsUpdate
     */
    userEmployeeId?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupDetailsUpdate
     */
    userLastName?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupDetailsUpdate
     */
    userFirstName?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupDetailsUpdate
     */
    userJobTitle?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupDetailsUpdate
     */
    userFleetRole?: boolean | null;
}

/**
 * Check if a given object implements the UserGroupDetailsUpdate interface.
 */
export function instanceOfUserGroupDetailsUpdate(value: object): value is UserGroupDetailsUpdate {
    return true;
}

export function UserGroupDetailsUpdateFromJSON(json: any): UserGroupDetailsUpdate {
    return UserGroupDetailsUpdateFromJSONTyped(json, false);
}

export function UserGroupDetailsUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupDetailsUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'userEmployeeId': json['userEmployeeId'] == null ? undefined : json['userEmployeeId'],
        'userLastName': json['userLastName'] == null ? undefined : json['userLastName'],
        'userFirstName': json['userFirstName'] == null ? undefined : json['userFirstName'],
        'userJobTitle': json['userJobTitle'] == null ? undefined : json['userJobTitle'],
        'userFleetRole': json['userFleetRole'] == null ? undefined : json['userFleetRole'],
    };
}

export function UserGroupDetailsUpdateToJSON(json: any): UserGroupDetailsUpdate {
    return UserGroupDetailsUpdateToJSONTyped(json, false);
}

export function UserGroupDetailsUpdateToJSONTyped(value?: UserGroupDetailsUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userEmployeeId': value['userEmployeeId'],
        'userLastName': value['userLastName'],
        'userFirstName': value['userFirstName'],
        'userJobTitle': value['userJobTitle'],
        'userFleetRole': value['userFleetRole'],
    };
}

